import { TrackingInfo } from '../types';

interface ValidationError {
  errorCode: string;
  errorMessage: string;
}

interface ValidationResponse {
  errorCode: undefined;
  errorMessage: undefined;
  result:
    | {
        event: TrackingInfo<unknown>;
        result: boolean;
      }[]
    // this is returned when there is some API error unrelated to the event validation
    | {
        error: string;
        message: string;
      };
}

type ValidationRequest = { id: string; value: TrackingInfo<unknown> }[];

export async function postEventValidation(
  url: string,
  body: ValidationRequest,
  apiToken: string
): Promise<ValidationError | ValidationResponse> {
  const response = await fetch(url, {
    method: 'post',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      token: apiToken,
    },
  } as RequestInit);

  try {
    const result = await response.json();
    if (!result.errorCode) {
      return { result } as ValidationResponse;
    } else {
      return result as ValidationError;
    }
  } catch (error) {
    return {
      errorCode: error.name,
      errorMessage: error.message,
    };
  }
}
